import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

const customStyles = {
  table: { style: { backgroundColor: 'transparent' } },
  headRow: { style: { backgroundColor: '#f8f9fa', borderBottom: '2px solid #dadfc1', minHeight: '45px' } },
  headCells: { style: { fontSize: '13px', fontWeight: 'bold', color: '#1f2d3d' } },
  rows: { style: { fontSize: '13px', minHeight: '60px', borderBottom: '1px solid #e3e6ec' }, highlightOnHoverStyle: { backgroundColor: '#e9ecef', transitionDuration: '0.1s' } },
};

const RakutenItemTagManager = () => {
  const [products, setProducts] = useState([]);
  const [tagDict, setTagDict] = useState({});
  const [loading, setLoading] = useState(false);
  const [copiedTagId, setCopiedTagId] = useState(null);

  // 🌟 APIからデータ（商品一覧 ＆ タグ翻訳辞書）を取得
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const token = localStorage.getItem('access_token');
        const headers = { 'Authorization': `Bearer ${token}` };

        // 1. タグ辞書の取得（ID -> 日本語名）
        const dictRes = await fetch(`${apiUrl}/rakuten-tags/dictionary`, { headers });
        const dictData = await dictRes.json();
        if (dictData.status === 'success') setTagDict(dictData.data);

        // 2. 商品一覧の取得（タグを持っている商品）
        const prodRes = await fetch(`${apiUrl}/rakuten-tags/products`, { headers });
        const prodData = await prodRes.json();
        if (prodData.status === 'success') setProducts(prodData.data);

      } catch (error) {
        console.error("データの取得に失敗しました", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // 🌟 URLをクリップボードにコピーする機能
  const handleCopyUrl = (url, tagId) => {
    navigator.clipboard.writeText(url);
    setCopiedTagId(tagId);
    setTimeout(() => setCopiedTagId(null), 2000); // 2秒後に「コピー完了」の表示を消す
  };

  // 🌟 データテーブルのカラム定義
  const columns = [
    {
      name: '商品情報',
      width: '300px',
      cell: row => (
        <div className="d-flex align-items-center py-2">
          <img src={row.image_url || '/assets/img/brand/shop.svg'} alt="商品" style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '4px', marginRight: '10px', border: '1px solid #eee' }} />
          <div>
            <div className="fw-bold fs-12px text-truncate" style={{ maxWidth: '220px' }} title={row.name}>{row.name}</div>
            <div className="text-muted fs-11px">{row.item_code}</div>
          </div>
        </div>
      )
    },
    {
      name: 'カラーパレット・タグURL生成',
      cell: row => {
        // タグがない場合は表示しない
        if (!row.tag_ids || row.tag_ids.length === 0) return <span className="text-muted fs-11px">タグ情報がありません</span>;

        // 店舗のID（ご自身の楽天店舗IDに書き換えてください。例：twinklegirlsの店舗IDは 300000 などの数字です）
        // ※分からない場合は、一旦 'twinklegirls' という文字でも楽天の検索仕様によっては動きます
        const shopId = "twinklegirls";

        return (
          <div className="d-flex flex-wrap gap-2 py-2">
            {row.tag_ids.map(tagId => {
              const tagName = tagDict[tagId] || `未登録タグ(${tagId})`;
              // 🌟 楽天の「店舗内タグ絞り込み検索URL」の基本フォーマット
              const targetUrl = `https://search.rakuten.co.jp/search/mall/?sid=${shopId}&tg=${tagId}`;

              const isCopied = copiedTagId === `${row.uuid}-${tagId}`;

              return (
                <div key={tagId} className="border rounded p-2 bg-light d-flex flex-column" style={{ minWidth: '150px' }}>
                  <span className="fw-bold fs-11px text-dark mb-1"><i className="fa fa-tag me-1 text-primary"></i>{tagName}</span>
                  <button
                    className={`btn btn-xs ${isCopied ? 'btn-success' : 'btn-outline-primary'}`}
                    onClick={() => handleCopyUrl(targetUrl, `${row.uuid}-${tagId}`)}
                  >
                    {isCopied ? <><i className="fa fa-check me-1"></i>コピー完了</> : <><i className="fa fa-copy me-1"></i>URLをコピー</>}
                  </button>
                </div>
              );
            })}
          </div>
        );
      }
    }
  ];

  return (
    <div>
      <ol className="breadcrumb float-xl-end">
        <li className="breadcrumb-item"><a href="#/">Home</a></li>
        <li className="breadcrumb-item active">タグ・カラー管理</li>
      </ol>
      <h1 className="page-header">カラーパレット管理 <small>タグURLの自動合成</small></h1>

      <div className="panel panel-inverse">
        <div className="panel-heading">
          <h4 className="panel-title">商品別 タグ一覧</h4>
          <div className="panel-heading-btn">
            <button className="btn btn-xs btn-icon btn-default" onClick={() => window.location.reload()}><i className="fa fa-redo"></i></button>
          </div>
        </div>
        <div className="panel-body">
          <DataTable
            columns={columns}
            data={products}
            progressPending={loading}
            progressComponent={<div className="text-center p-4"><div className="spinner-border text-primary"></div></div>}
            customStyles={customStyles}
            pagination
            highlightOnHover
            noDataComponent={<div className="p-4 text-muted">タグ情報を持つ商品が見つかりません。バッチ処理を実行してください。</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default RakutenItemTagManager;